var map = {
	"./icon-analytics.svg": 7298,
	"./icon-browser.svg": 4878,
	"./icon-calendar.svg": 7600,
	"./icon-caret.svg": 4363,
	"./icon-check.svg": 1802,
	"./icon-clock-2.svg": 5629,
	"./icon-clock.svg": 4464,
	"./icon-coins.svg": 6268,
	"./icon-currency.svg": 5295,
	"./icon-dashboard.svg": 6938,
	"./icon-decimal.svg": 2263,
	"./icon-drag.svg": 424,
	"./icon-edit.svg": 2734,
	"./icon-favorite-outline.svg": 3551,
	"./icon-favorite.svg": 1454,
	"./icon-filter-caret.svg": 7074,
	"./icon-globe.svg": 9857,
	"./icon-home.svg": 5371,
	"./icon-items.svg": 7398,
	"./icon-left.svg": 5321,
	"./icon-list.svg": 7990,
	"./icon-lock.svg": 5219,
	"./icon-mail.svg": 7607,
	"./icon-minus.svg": 3702,
	"./icon-no-decimal.svg": 9381,
	"./icon-note.svg": 4374,
	"./icon-phone.svg": 3210,
	"./icon-plus.svg": 9950,
	"./icon-quote.svg": 1294,
	"./icon-refresh.svg": 9551,
	"./icon-scissor.svg": 6164,
	"./icon-sort-ascending.svg": 6431,
	"./icon-sort-descending.svg": 8357,
	"./icon-trash.svg": 644,
	"./icon-user-fill.svg": 4215,
	"./icon-user.svg": 3563,
	"./icon-wallet.svg": 7261,
	"./icon-warning-solid.svg": 3052,
	"./icon-warning.svg": 6830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2110;